import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "./PolicyModal.scss";
import Policies from "./Policies";
import PolicyDetail from "./PolicyDetail";
import AllDataClass from "pages/common/AllDataClass";

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  data: any;
  catIdx: number;
  selectedPolicyLists: any;
  setSelectedPolicyLists: React.Dispatch<React.SetStateAction<any[]>>;
  setMouseOver: React.Dispatch<React.SetStateAction<any>>;
};

const PolicyModal = ({
  open,
  handleClose,
  data,
  catIdx,
  selectedPolicyLists,
  setSelectedPolicyLists,
  setMouseOver,
}: ModalProp) => {
  // console.log(data);
  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [policyData, setPolicyData] = useState({});
  const [swiperInstance, setSwiperInstance] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  if (!data) return;

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const detailModalHandler = (idx: any) => {
    setPolicyData(data[6][idx]);
    setPolicyModalOpen(true);
    return;
  };
  const handlerClosePolicyDetail = () => {
    setPolicyModalOpen(false);
  };
  const creatSwiperSlide = (datas: any[]) => {
    if (!datas) return;
    var i, j;
    var swipers = [];
    for (i = 0; i < datas.length; i = i + 3) {
      var policies = [];
      for (j = 0; j < 3 && i + j < datas.length; j++) {
        var policy_id = Object.keys(datas[i + j])[0];
        policies.push(
          <Policies
            policyname={datas[i + j][policy_id][0]}
            data={datas[i + j]}
            detailModalHandler={detailModalHandler}
            idx={i + j}
            catIdx={catIdx}
            setMouseOver={setMouseOver}
          />
        );
      }
      swipers.push(<SwiperSlide key={i}>{policies}</SwiperSlide>);
    }
    return swipers;
  };
  return (
    <div>
      <PolicyDetail
        policyModalOpen={policyModalOpen}
        handleClose={handlerClosePolicyDetail}
        policy={policyData}
        category={data[0]}
        selectedPolicyLists={selectedPolicyLists}
        setSelectedPolicyLists={setSelectedPolicyLists}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="policy-modal-main"
      >
        <div className="modal-content">
          <div className="modal-content-wrap">
            <div className="policy-modal-main-back" onClick={handleClose}>
              <div className="back-img" />
              {data[0]}
            </div>
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
              onSwiper={setSwiperInstance} // Store Swiper instance
              // autoplay={{
              //   delay: 10000,
              //   disableOnInteraction: false,
              // }}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="myPolicyswiper"
            >
              {creatSwiperSlide(data[6])}
              <div className="swiper-button-wrap">
                <button className="custom-button prev" ref={prevRef} />
                <button className="custom-button next" ref={nextRef} />
              </div>
            </Swiper>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PolicyModal;
